import { useQuery } from "@tanstack/react-query";
import { chatService } from "@/services/chat-service";

const internalChatTokenQueryKey = "internal-chat-token";

export const useInternalChatToken = (enabled = true) => {
  const {
    data: userChatData,
    isLoading,
    error,
  } = useQuery({
    queryKey: [internalChatTokenQueryKey],
    queryFn: async () => chatService.getInternalUserChatToken(),
    enabled,
  });

  return {
    userChatData,
    isLoading,
    error,
  };
};
